import '../assets/slider.scss'
import React, {useState, useEffect, useRef} from 'react'
import { __ } from '@wordpress/i18n';
import {TextControl, TextareaControl, Button, Icon, PanelBody, PanelRow, ToggleControl, Modal, SelectControl, CheckboxControl, RadioControl, ToolbarButton} from "@wordpress/components"
import {InspectorControls, MediaUpload, MediaUploadCheck, BlockControls, AlignmentToolbar} from "@wordpress/block-editor"

function TomSIamgeSlider(slider) {
    
    function onChangeImageSlider(newValue){
        slider.props.setAttributes({imageSlider: newValue})
    }
    function onChangeAutoPlay(newValue){
        slider.props.setAttributes({autoPlay: newValue})
    }
    function onChangeThumnbail(newValue){
        slider.props.setAttributes({thumnbail: newValue})
    }
    function onChangeSliderModal(newValue){
        slider.props.setAttributes({sliderModal: newValue})
    }
    function onChangeEditorSliderModal(newValue){
        slider.props.setAttributes({editorSliderModal: newValue})
    }
    
    return (
        <>
        <InspectorControls>{/* Slider settings */}
            <PanelBody title={__("Slider Settings", "toms-image-slider")} initialOpen={ true }>
                <PanelRow>
                    <ToggleControl
                        label={__("Image Slider ", "toms-image-slider")}
                        help={ slider.props.attributes.imageSlider ? '' : __("Disable this Image Slider if you do not want to show the slideshow to the frontend.", "toms-image-slider")}
                        checked={ slider.props.attributes.imageSlider }
                        onChange={ onChangeImageSlider }
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label={__("Auto Play ", "toms-image-slider")}
                        help={ slider.props.attributes.autoPlay ? '' : __("Disabled Auto Play", "toms-image-slider")}
                        checked={ slider.props.attributes.autoPlay }
                        onChange={ onChangeAutoPlay }
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label={__("Thumnbail ", "toms-image-slider")}
                        help={ slider.props.attributes.thumnbail ? '' : __("Disabled Thumnbail", "toms-image-slider")}
                        checked={ slider.props.attributes.thumnbail }
                        onChange={ onChangeThumnbail }
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label={__("Modal ", "toms-image-slider")}
                        help={ slider.props.attributes.sliderModal ? '' : __("Disabled Modal", "toms-image-slider")}
                        checked={ slider.props.attributes.sliderModal }
                        onChange={ onChangeSliderModal }
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label={__("Modal preview in Editor", "toms-image-slider")}
                        help={ slider.props.attributes.editorSliderModal ? __("Enabled Modal preview in current Editor, to make this option work you need to enable Modal first.", "toms-image-slider") : ''}
                        checked={ slider.props.attributes.editorSliderModal }
                        onChange={ onChangeEditorSliderModal }
                    />
                </PanelRow>
            </PanelBody>
        </InspectorControls>

        {/* Slider Preview */}
        {slider.props.attributes.imageSlider !== false ? (
            <TomsImageSliderPreview {...slider} /> /*调用自定义component*/
        ):(
            <div style={{width: '280px', height: '280px', backgroundColor: '#e5ffd5', fontSize: '20px', fontWeight: 'bold', padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center'}}>
                <p>
                    <svg t="1633403139510" className="toms-disabled-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13033" width="80" height="80"><path d="M511.175727 162.355715c-192.325283 0-349.669868 157.343561-349.669868 349.669868 0 192.276165 157.344584 349.619726 349.669868 349.619726s349.669868-157.343561 349.669868-349.619726C860.845595 319.699276 703.502034 162.355715 511.175727 162.355715M231.470327 512.024559c0-153.886833 125.890198-279.758612 279.7054-279.758612 62.945611 0 122.361839 20.974707 171.375136 59.46637l-391.670447 391.594723C252.46857 634.386398 231.470327 574.947657 231.470327 512.024559M511.175727 791.729959c-62.952774 0-122.360815-20.973684-171.329087-59.438741l391.617236-391.617236c38.465057 48.940642 59.416228 108.407012 59.416228 171.3516C790.881127 665.862273 665.036977 791.729959 511.175727 791.729959" p-id="13034" fill="#d81e06"></path></svg>
                    <svg t="1633403574862" className="toms-unvisible-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31920" width="80" height="80"><path d="M930.9 456.1c-28.7-31.3-75.8-77.9-137.2-121.7-9.9-7.1-23.6-4.8-30.7 5.1-7.1 9.9-4.8 23.6 5.1 30.7 61.4 43.8 108 91.3 130.4 115.7 4.8 5.2 4.8 12.9 0 18.1-26.6 29-81.9 84.6-154.5 132.2-86.5 56.7-171.4 85.4-252.4 85.4-29.5 0-60-3.9-90.5-11.6-11.8-2.9-23.7 4.2-26.7 16-2.9 11.8 4.2 23.7 16 26.7 34.1 8.6 68.1 12.9 101.2 12.9 89.7 0 182.7-31.1 276.5-92.7 76.6-50.2 134.9-108.7 162.8-139.2 20.3-22.1 20.3-55.5 0-77.6zM870.7 115.9c-8.6-8.6-22.5-8.6-31.1 0L685 270.5c-65.6-30.6-130.7-46.1-193.4-46.1-89.7 0-182.7 31.2-276.5 92.6-76.6 50.2-134.9 108.7-162.8 139.2-20.3 22.1-20.3 55.5 0 77.6C88 572.7 161.2 644.9 257 698.5L112.4 843.1c-8.6 8.6-8.6 22.5 0 31.1 4.3 4.3 10 6.4 15.6 6.4s11.2-2.1 15.5-6.4L870.7 147c8.6-8.6 8.6-22.5 0-31.1zM425 317.5c41.7 0 75.5 33.8 75.5 75.5s-33.8 75.5-75.5 75.5-75.5-33.8-75.5-75.5c0-41.8 33.8-75.5 75.5-75.5z m198.9-24.8c9.3 3.3 18.6 7 27.9 11l-7.5 7.5c-6.4-6.6-13.2-12.7-20.4-18.5zM287.3 664.9C192.6 614 119.8 542.3 84.8 504.1c-4.8-5.2-4.8-12.9 0-18.1 26.5-29 81.8-84.6 154.4-132.2 40.3-26.4 80.2-46.7 119.6-60.9-49 39-80.4 99.2-80.4 166.7 0.1 59.9 25 114 64.8 152.7l-53.9 53.9c-0.6-0.5-1.3-0.9-2-1.3z" p-id="31921" fill="#bfbfbf"></path><path d="M491.6 672.6c117.7 0 213.1-95.4 213.1-213.1 0-18.3-2.5-35.9-6.9-52.8l-259 259c16.9 4.3 34.5 6.9 52.8 6.9z" p-id="31922" fill="#bfbfbf"></path></svg>
                </p>
                <div>{__("This Block has been", "toms-image-slider")} <span style={{color: '#ff0000', fontSize: '30px'}}>{__("Disabled", "toms-image-slider")}</span> !</div>
            </div>
        )
        }
        </>
    )
}

const TomsImageSliderPreview = (slides) => {     /* 自定义component */
    var defaultImageFromPHP = tomsSlieshowDefaultFromPHP.defaultImage

    const { isSelected } = slides.props
    const [current, setCurrent] = useState(0)
    const [currentImg, setCurrentImg] = useState(slides.props.attributes.galleryImages[0])
    const length = slides.props.attributes.galleryImages.length
    const slideImg = slides.props.attributes.galleryImages
    
    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1),
        setCurrentImg(slideImg[current === length - 1 ? 0 : current + 1])

        isOpen && (setModalImg(slideImg[current === length - 1 ? 0 : current + 1]))
    }

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1),
        setCurrentImg(slideImg[current === 0 ? length - 1 : current - 1])

        isOpen && (setModalImg(slideImg[current === 0 ? length - 1 : current - 1]))
    }
    
    //自动滑动 autoplay
    const timeoutRef = useRef(null);
    function resetTimeout() { /*清空计时函数*/
        if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        }
    }
    useEffect(() => {
        if( slides.props.attributes.autoPlay !== false && length >=1 ){
            resetTimeout(); /*清空计时*/

            timeoutRef.current = setTimeout( () => {
                setCurrent(current === length - 1 ? 0 : current + 1),
                setCurrentImg(slideImg[current === length - 1 ? 0 : current + 1])
            }, 3600 )

            return () => {
                resetTimeout(); /*返回清空计时*/
            }
        }
    }, [current])

    //图片弹窗
    const [ isOpen, setOpen ] = useState( false );
    const openModal = () => slides.props.attributes.sliderModal !== false && slides.props.attributes.editorSliderModal === true && setOpen( true );
    const closeModal = () => setOpen( false );
    
    const [modalCurrent, setModalCurrent] = useState(0)
    const [modalImg, setModalImg] = useState(slides.props.attributes.galleryImages[0])
    
    const modalNextSlide = () => {
        setModalCurrent(modalCurrent === length - 1 ? 0 : modalCurrent + 1)
        setModalImg(slideImg[modalCurrent === length - 1 ? 0 : modalCurrent + 1])
    }

    const modalPrevSlide = () => {
        setModalCurrent(modalCurrent=== 0 ? length - 1 : modalCurrent - 1)
        setModalImg(slideImg[modalCurrent === 0 ? length - 1 : modalCurrent - 1])
    }
    
    //控制显示缩略图
    const [showState, setShowState] = useState({shown:true})
    function showThumnbail(){
        return(
            setShowState({shown: !showState.shown})
        )
    }

    if(!Array.isArray(slides.props.attributes.galleryImages)){ /*判断图片的值是否小于0 或者是数组*/
        return null;
    }
    function deleteSliderImage(indexToDelete) {
        const gelleryImage = slides.props.attributes.galleryImages.filter(function(x, gelleryImageIndex) {
            return gelleryImageIndex != indexToDelete
        })
        slides.props.setAttributes({
            galleryImages: gelleryImage
        })
    }
    return(
        <>
        <section className="toms-image-slider-preview">
            <div className="toms-image-slider-image">
                <span className='left-arrow' onClick={prevSlide}>
                <Icon
                    icon={ () => (
                        <svg t="1632461798804" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8849" width="32" height="32">
                            <path d="M804.157345 1024H596.658663c-9.595315 0-18.790825-4.297901-24.787897-11.794241L247.229283 612.600878c-47.776672-58.771303-47.776672-142.93021 0-201.701512L571.470961 11.794241c6.097023-7.49634 15.192582-11.794241 24.787897-11.794241h206.799024c6.69673 0 10.494876 7.796193 6.196974 12.993655L436.936652 471.369839c-19.090678 23.488531-19.090678 57.172084 0 80.760566l373.417667 458.775988c4.19795 5.297413 0.499756 13.093607-6.196974 13.093607z" p-id="8850"></path>
                        </svg>
                    )}
                />
                </span>

                <div className="toms-image-slider-active-image" onClick={ openModal } >
                    { /*slides.props.attributes.galleryImages.map(
                        function (img, index){
                            return (
                                <>
                                    <div className={index === current ? 'toms-image-slider-slide toms-image-slider-slide-active' : 'toms-image-slider-slide'} key={index} >
                            {index === current && !!(img) &&( */}
                            {!!(slideImg[current]) ? (
                                <img src={slideImg[current]} className="toms-image-slider-gellery-image" width="200" height="200" /> 
                            ) : (
                                <img src={defaultImageFromPHP} className="toms-image-slider-gellery-image" width="200" height="200" /> 
                            )}
                                        {/*)}
                                    </div>
                                </>
                            )}
                            )*/}
                </div>

                <span className='right-arrow' onClick={nextSlide}>
                <Icon
                    icon={ () => (
                        <svg t="1632461740711" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8565" width="32" height="32">
                            <path d="M776.270961 612.600878l-324.641483 399.604881c-6.097023 7.49634-15.192582 11.794241-24.787897 11.794241H219.44285c-6.69673 0-10.494876-7.796193-6.196974-13.093607l373.317716-458.875939c19.090678-23.488531 19.090678-57.172084 0-80.760566L214.145437 12.993655c-4.297901-5.197462-0.499756-12.993655 6.196974-12.993655h206.799024c9.595315 0 18.790825 4.297901 24.787896 11.794241l324.34163 399.105125c47.776672 58.771303 47.776672 142.93021 0 201.701512z" p-id="8566"></path>
                        </svg>
                    )} 
                />
                </span>
            </div>
            {slides.props.attributes.thumnbail !== false && (
            <div className="toms-image-slider-thumnbail">
                {slides.props.attributes.galleryImages.map(
                    function (slide, index){
                        if(index >= 0){
                        return(
                            <span className="toms-image-slider-thumnbail-image">
                                {!!(slide) &&(
                                <img src={slide} className={index === current ? 'toms-image-slider-gellery-thumnbail-image toms-image-slider-gellery-thumnbail-image-active' : 'toms-image-slider-gellery-thumnbail-image'} width="200" height="200" onClick={() => { setCurrentImg(slide), setCurrent(index) } } />
                                )}
                            </span>
                        )}
                })}
            </div>
            )}
            { isOpen && (
                <Modal className="toms-image-slider-modal-block" overlayClassName="toms-image-slider-modal-overlay" onRequestClose={ closeModal } style={{backgroundImage: `url(${!!(slideImg[modalCurrent]) ? (slideImg[modalCurrent]) : '' })`}}>
                    <div className="toms-image-slider-modal-block">
                        {/*<div className="toms-image-slider-modal-main">
                        </div>*/}
                            <span className='modal-left-arrow' onClick={modalPrevSlide}>
                                <Icon
                                    icon={ () => (
                                        <svg t="1632461688518" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8373" width="64" height="64">
                                            <path d="M804.157345 1024H596.658663c-9.595315 0-18.790825-4.297901-24.787897-11.794241L247.229283 612.600878c-47.776672-58.771303-47.776672-142.93021 0-201.701512L571.470961 11.794241c6.097023-7.49634 15.192582-11.794241 24.787897-11.794241h206.799024c6.69673 0 10.494876 7.796193 6.196974 12.993655L436.936652 471.369839c-19.090678 23.488531-19.090678 57.172084 0 80.760566l373.417667 458.775988c4.19795 5.297413 0.499756 13.093607-6.196974 13.093607z" p-id="8374"></path>
                                        </svg>
                                    )}
                                />
                            </span>
                            {/*<div className="toms-image-slider-modal">
                            slides.map(
                                function (slide, index){
                                    return(
                                        <div className="toms-image-slider-modal">
                                        {index === modalCurrent && (
                                                <img src={modalImg} className="toms-image-slider-modal-image" width="200" height="200" />
                                        )}
                                        </div>
                                    )
                            })
                            </div>*/}
                        
                        {slides.props.attributes.thumnbail !== false && (
                        <>
                            <span  className="toms-image-slider-modal-show-thumnbail-icon" onClick={showThumnbail}>
                                <Icon
                                    icon={
                                        <svg t="1632467128148" className="thumnbail-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15012" width="48" height="48">
                                            <path d="M992 96H160a32 32 0 0 0-32 32v96H32a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32v-96h96a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zM832 288v506.416l-171.168-146.72a32 32 0 0 0-37.296-3.136l-137.056 82.24-206.4-235.872a32.048 32.048 0 0 0-23.008-10.912 32.192 32.192 0 0 0-23.68 9.36L64 658.752V288h768zM64 749.248l190.432-190.432 201.488 230.272a31.952 31.952 0 0 0 40.544 6.352l140.224-84.128L814.832 864H64v-114.752zM960 736h-64V256a32 32 0 0 0-32-32H192v-64h768v576z" p-id="15013"></path><path d="M656 576c61.744 0 112-50.256 112-112s-50.256-112-112-112-112 50.256-112 112 50.256 112 112 112z m0-160c26.464 0 48 21.536 48 48s-21.536 48-48 48-48-21.536-48-48 21.536-48 48-48z" p-id="15014"></path>
                                        </svg>
                                    }
                                />
                            </span>
                            {showState.shown === true &&
                            <div className="toms-image-slider-modal-thumnbail">
                                {slides.props.attributes.galleryImages.map(
                                    function (slide, index){
                                        if(index >= 0){
                                        return(
                                            <span className="toms-image-slider-modal-thumnbail-image">
                                                <img src={slide} className={index === modalCurrent ? 'toms-image-slider-gellery-modal-thumnbail-image toms-image-slider-gellery-modal-thumnbail-image-active' : 'toms-image-slider-gellery-modal-thumnbail-image'} width="200" height="200" onClick={() => { setModalImg(slide), setModalCurrent(index) } } />
                                            </span>
                                        )}
                                })}
                            </div>
                            }
                        </>
                        )}
                        <span className='modal-right-arrow' onClick={modalNextSlide}>
                            <Icon
                                icon={ () => (
                                    <svg t="1632461620854" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8135" width="64" height="64">
                                        <path d="M776.270961 612.600878l-324.641483 399.604881c-6.097023 7.49634-15.192582 11.794241-24.787897 11.794241H219.44285c-6.69673 0-10.494876-7.796193-6.196974-13.093607l373.317716-458.875939c19.090678-23.488531 19.090678-57.172084 0-80.760566L214.145437 12.993655c-4.297901-5.197462-0.499756-12.993655 6.196974-12.993655h206.799024c9.595315 0 18.790825 4.297901 24.787896 11.794241l324.34163 399.105125c47.776672 58.771303 47.776672 142.93021 0 201.701512z" p-id="8136"></path>
                                    </svg>
                                )} 
                            />
                        </span>
                    </div>
                </Modal>)
            }
        </section>
        {isSelected && slides.props.attributes.imageSlider !== false &&
            <div className="toms-image-slider-settings">
                {slides.props.attributes.galleryImages.map(
                    function (images, index){
                        return(
                            <div className="toms-image-slider-image-url">
                                <div className="toms-image-slider-image-urls">
                                <TextControl label={__("Image Url", "toms-image-slider")+ ' ' + index} className="toms-image-slider-text-control"  placeholder={__("Image url", "toms-image-slider")} value={images} onChange={ newImage => {
                                    const newImages = slides.props.attributes.galleryImages.concat([])
                                    newImages[index] = newImage
                                    slides.props.setAttributes({galleryImages: newImages})
                                }}/>
                                </div>
                                {index >= 1 ? (
                                <Button variant="link" title={__("Remove this line!!!", "toms-image-slider")} className="toms-image-slider-delete"  onClick={() => deleteSliderImage(index)} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="bi bi-x-octagon-fill" viewBox="0 0 16 16">
                                        <path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>
                                    </svg>
                                </Button>
                                ) : (
                                    <Button variant="link" className="toms-image-slider-delete" style={{width: '24px'}} ></Button>
                                )}
                            </div>
                        )
                })}
                <div className="toms-image-slider-button">
                    <div className="add-image-button">
                    <Button variant="primary" onClick={() => {
                            slides.props.setAttributes({
                                galleryImages: slides.props.attributes.galleryImages.concat([''])
                            })
                        }}>{__("Add Image", "toms-image-slider")}
                    </Button>
                    </div>
                </div>
            </div>
            }
        </>
    )
}

export default TomSIamgeSlider;